import { z } from 'zod';

import {
  IsoDateSchema,
  IsoDateTimeSchema,
  HttpUrlSchema,
  NonEmptyStringSchema,
  QidSchema,
  Sha256Schema,
} from './primitives.js';

export const SourceClassSchema = z.enum([
  'official',
  'reference',
  'reputable-publication',
  'authority',
  'wikidata',
  'unclassified',
]);

export type SourceClass = z.infer<typeof SourceClassSchema>;

export const SourceSchema = z.object({
  id: NonEmptyStringSchema,
  title: NonEmptyStringSchema.optional(),
  publisher: NonEmptyStringSchema.optional(),
  url: HttpUrlSchema,
  publishedAt: IsoDateSchema.optional(),
  archivedUrl: HttpUrlSchema.optional(),
  sourceClass: SourceClassSchema,
  retrievedAt: IsoDateTimeSchema,
});

export type Source = z.infer<typeof SourceSchema>;

const QualifiedReferenceDateSchema = z.object({
  iso: NonEmptyStringSchema,
  precision: z.enum(['day', 'month', 'year', 'decade']),
});

export const ReferenceEvidenceSchema = z.object({
  id: Sha256Schema,
  referenceUrls: z.array(HttpUrlSchema),
  statedInQids: z.array(QidSchema),
  authorityIds: z.array(NonEmptyStringSchema),
  importedFromQids: z.array(QidSchema),
  retrievedAt: QualifiedReferenceDateSchema.optional(),
});

export type ReferenceEvidence = z.infer<typeof ReferenceEvidenceSchema>;

export const EvidenceClassificationSchema = z.object({
  qualifyingSourceIds: z.array(NonEmptyStringSchema),
  retainedSourceIds: z.array(NonEmptyStringSchema),
  hasNonQualifyingSources: z.boolean(),
  reasons: z.array(NonEmptyStringSchema),
});

export type EvidenceClassification = z.infer<typeof EvidenceClassificationSchema>;
